import { createFileRoute } from "@tanstack/react-router";
import CTASection from "./_components/CTASection";
import FeaturesSection from "./_components/FeaturesSection";
import GoldDivider from "./_components/GoldDivider";
import HeroSection from "./_components/HeroSection";
import WorkflowSection from "./_components/WorkflowSection";

export const Route = createFileRoute("/_public/")({
  component: Index,
});

function Index() {
  return (
    <div className="flex-1 container mx-auto flex flex-col gap-12 px-6 py-12">
      {/* ── Hero ── */}
      <HeroSection />

      <GoldDivider />

      {/* ── Features ── */}
      <FeaturesSection />
      <GoldDivider />

      {/* ── Workflow ── */}
      <WorkflowSection />

      <GoldDivider />

      {/* ── CTA ── */}
      <CTASection />
    </div>
  );
}
